let folder = 'privacy-policy'
export const state = () => ({
  meta: null,
  stage: null,
  content: null,
  contact: null
})
export const getters = {
  meta(state) {
    return state.meta
  },
  stage(state) {
    return state.stage
  },
  content(state) {
    return state.content
  },
  contact(state) {
    return state.contact
  }
}
export const mutations = {
  setMeta(state, { data }) {
    state.meta = data
  },
  setStage(state, { data }) {
    state.stage = data
  },
  setContent(state, { data }) {
    state.content = data
  },
  setContact(state, { data }) {
    state.contact = data
  }
}
export const actions = {
  getMeta({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/meta.json`)
      .then((res) => {
        commit('setMeta', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getStage({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/stage.json`)
      .then((res) => {
        commit('setStage', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getContent({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/content.json`)
      .then((res) => {
        commit('setContent', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getContact({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/contact.json`)
      .then((res) => {
        commit('setContact', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  }
}
